.root {
  padding: 19px 12px;
  border-top: 1px solid rgb(0 0 0/ 12%);
  border-bottom: 1px solid rgb(0 0 0/ 12%);
}
